import { render } from "./BillingAddressCartB2B.vue?vue&type=template&id=561960de"
import script from "./BillingAddressCartB2B.vue?vue&type=script&lang=js"
export * from "./BillingAddressCartB2B.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\Studio Sport\\ECM_HYBRID_STUDIO_SPORT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__